import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none text-[10rem] font-black text-background-200 md:text-[14rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
          <i className="ri-error-warning-line" aria-hidden="true" />
          页面走丢了
        </span>
        <p className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          你访问的页面不存在
        </p>
        <p className="mt-2 text-sm text-foreground-500">路径：{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
      </div>
    </div>
  );
}